import { PageHeader } from "components/ui";
import React from 'react';
import { Grid, Typography, Box } from "@mui/material";
import CustomButton from '../../components/buttonsComponent/StyledButton';
import { fontFamily, fontSize } from '../../../node_modules/@mui/system/index';
import { Outlet } from 'react-router-dom';
import NavigationButtons from 'helper/navigation/NavigationButtons';
import GriEmpowerment from "../../assets/images/GriEmpowerment.png"

const SdgReporting = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} >
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <PageHeader
            title="AI-Powered ESG Reporting across Global, National, Sectoral, and Industry-Specific Standards"
          />
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Box className="gri-header">
          <NavigationButtons imageKey="SDG" title={"SDG Reporting"} activeStep={0} />
        </Box>
      </Grid>
      <Grid item xs={12} >
        <Box
          sx={{
            borderRadius: '8px',
            padding: '24px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Box sx={{ flex: 1 }} >
            <Typography
              className="mb-4"
              variant="h6"
              style={{
                fontWeight: 700,
                color: '#02462E',
                mb: 3,
                fontSize: "40px",
                fontFamily: "DM Sans",
                lineHeight: "38px",
                letterSpacing: "-2%",
              }}
            >
              The global standards for Environmental <br />sustainability.            </Typography>

            <Box
              sx={{
                display: 'flex',
                flexDirection: { xs: 'column', md: 'row' },
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: { xs: 4, md: 8 },
                flexWrap: 'wrap',
              }}
            >
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <CustomButton title="What is SDG?" route="/reporting/sdg/whatissdg" />
                <CustomButton title="SDG Compliances" route="/reporting/sdg/sdg-compliace" />
              </Box>

              {/* <Box
                                component="img"
                                src={GriEmpowerment}
                                alt="Gri Empowerment"
                                sx={{
                                    width: '192px',
                                    height: '202px',
                                    ml: { xs: 0, md: 4 },
                                    mt: { xs: 4, md: 0 },
                                }}
                            /> */}
            </Box>


          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};


export default SdgReporting
